<template>
    <div class="tsa-tableActionPopover" :class="type ? type : ''">
        <el-popover
            ref="popover"
            placement="bottom-end"
            width="130"
            popper-class="table-popper"
            trigger="click"
            @show="handleShow"
            @hide="handleHide"
        >
            <!--  hover -->
            <div class="table-popper-content">
                <slot></slot>
            </div>
            <div class="detail" slot="reference" @click.stop="">
                <p>{{ text }}</p>
                <span class="icon tsa-icon-arrow-down2"></span>
            </div>
        </el-popover>
    </div>
</template>

<script>
export default {
    props: {
        text: {
            type: String,
            default: ''
        },
        type: {
            type: String,
            default: '', // btn
        },
    },
    data(){
        return {
            visible:false
        }
    },
    mounted () {
    },
    beforeDestroy() {
        // 组件销毁前移除监听
        window.removeEventListener('scroll', this.handleScroll, true)
    },
    methods: {
        handleShow() {
            this.visible = true
            // 添加滚动监听
            window.addEventListener('scroll', this.handleScroll, true)
        },
        handleHide() {
            this.visible = false
            // 移除滚动监听
            window.removeEventListener('scroll', this.handleScroll, true)
        },
        handleScroll() {
            if (this.visible) {
                // 关闭 popover
                this.$refs.popover.doClose()
                this.visible = false
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.tsa-tableActionPopover {
    display: flex;
    align-items: center;
    &.button {
        .detail {
            padding: 0 14px;
            height: 32px;
            background: #FFFFFF;
            border-radius: 4px;
            border: 1px solid #E8E9EB;
            color: #151B26;
            &:hover {
                background: #efefef;
            }
            p {
                margin-right: 8px;
            }
        }
    }
    .detail {
        width: max-content;
        display: flex;
        align-items: center;
        cursor: pointer;
        font-size: 14px;
        color: #2468F2;
        flex-shrink: 0;
        p {
            
        }
        .icon {

        }
    }
}
</style>